export default () => ({
  isOpenFilter: false,
  pagination: {},
  filter: {},
  rows: [],
  row: null,
  all_rows: [],
  rowEdit: null,
  loading: {},
  modal: {},
});
